import { AdminGroupsPage } from '@features/admin/components/AdminGroupsPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/admin/groups')({ component: AdminGroupsPage });
